import type { ReactiveElement } from 'lit';

interface MonitorOptions {
  delayMonitorUntilFirstUpdate?: boolean;
}

interface Observer {
  method: (...args: unknown[]) => void;
  keys: PropertyKey[];
  options: MonitorOptions;
}

export const observersForClass = new WeakMap<
  // eslint-disable-next-line @typescript-eslint/ban-types
  Function,
  Observer[]
>();

// NOTE: legacy (experimental) decorators cannot infer the host element type from
// the decoration target under TS6/7, so this takes plain property keys rather than
// `keyof T`. The keys are only stored as PropertyKey[] anyway.
export function monitor(properties: PropertyKey | PropertyKey[], monitorOptions?: MonitorOptions) {
  const options: Required<MonitorOptions> = {
    delayMonitorUntilFirstUpdate: false,
    ...monitorOptions
  };

  const monitoredProperties = Array.isArray(properties) ? properties : [properties];

  return function (target: ReactiveElement, _propertyKey: string | symbol, descriptor: PropertyDescriptor) {
    let observers = observersForClass.get(target.constructor);
    if (observers === undefined) {
      observersForClass.set(target.constructor, (observers = []));
    }
    observers.push({ keys: monitoredProperties, method: descriptor.value!, options });
  };
}
